import imageError from "@website/accommodation-ui/tour-result-messages/assets/error-art.png";
import imageNotFound from "@website/accommodation-ui/tour-result-messages/assets/not-found-art.png";
import imageLoading from "@website/accommodation-ui/tour-result-messages/assets/searching-art.png";
import { TourResultMessageSchemaType } from "@website/accommodation-ui/tour-result-messages/types";

export const TourResultMessageSchema: TourResultMessageSchemaType = {
  ERROR: {
    image: (imageError as unknown as { src: string }).src,
    message: "خطایی رخ داده است!",
    caption: "متاسفانه اطلاعاتی یافت نشد.",
    buttonTitle: "بازگشت به صفحه اصلی",
    buttonIcon: "arrow_forward"
  },
  NOTFOUND: {
    image: (imageNotFound as unknown as { src: string }).src,
    message: "نتیجه‌ای یافت نشد.",
    caption: "متاسفانه در این تاریخ توری برای ",
    continueCaption1: "پیدا نشد. لطفا تاریخ دیگری را جستجو کنید."
  },
  LOADING: {
    image: (imageLoading as unknown as { src: string }).src,
    message: "جستجوی تور‌های",
    caption: "در حال پیدا کردن بهترین تور‌ها برای شما هستیم."
  },
  NOTFOUND_FILTER: {
    image: (imageNotFound as unknown as { src: string }).src,
    message: "نتیجه‌ای یافت نشد.",
    caption:
      "متاسفانه در حال حاضر تور متناسب با فیلتر های انتخابی شما وجود ندارد.",
    buttonTitle: "حذف فیلترها",
    buttonIcon: "delete_outline"
  },
  NOTFOUND_FILTER_ROOM: {
    image: (imageNotFound as unknown as { src: string }).src,
    message: "نتیجه‌ای یافت نشد.",
    caption:
      "متاسفانه در حال حاضر تور (اتاق و پرواز) متناسب با فیلتر های انتخابی شما وجود ندارد.",
    buttonTitle: "حذف فیلترها",
    buttonIcon: "delete_outline"
  },
  NOTFOUND_ROOM: {
    image: (imageNotFound as unknown as { src: string }).src,
    message: "نتیجه‌ای یافت نشد.",
    caption: "متاسفانه در این تاریخ اتاق و پروازی برای ",
    continueCaption1: "پیدا نشد. لطفا تاریخ دیگری را جستجو کنید."
  }
};
